export default "__VITE_ASSET__f53c1be0__"